import { useEffect } from 'react';
import AttToken from '../../../../helpers/attToken';
import Clients, { ClientType } from '../../../../service/Clients';
import { Label } from '../../../Notifications/style/SingleNotificationStyle';
import { useTranslation } from 'react-i18next';
import { StyledH1Subitem } from './FormModalStyle';
import { WeightInput } from '../../FormStyle';
import Checklists, { ChecklistSubitem, ChecklistType, SubitemChecklist } from '../../../../service/Checklists';
import TicketsAndNotifications, { typeToSend } from '../../../../service/Tickets_Notifications';
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, Skeleton, Stack, TextField } from "@mui/material";
import { trackEventMatomo } from "../../../../helpers/matomo";
import QueryFn from "../../../../helpers/QueryFn";

type props = {
  setEditModal: Function,
  form: ChecklistType,
  selectedCustomer: string,
  setSelectedCustomer: Function,
  chamadoObrigatorio: string,
  setChamadoObrigatorio: Function,
  tipoChamado: number[] | null,
  setTipoChamado: Function,
  limiteChamado: number | null,
  setLimiteChamado: Function,
  selectedSub: string,
  setSelectedSub: Function,
  canShow: boolean,
  setCanShow: Function,
  clearStates: Function,
};

const customerService = new Clients();
const NotificationsService = new TicketsAndNotifications();
const checklistService = new Checklists();
const queryFn = new QueryFn();

export default function SubItemTab({
  form,
  selectedCustomer,
  setSelectedCustomer,
  chamadoObrigatorio,
  setChamadoObrigatorio,
  tipoChamado,
  setTipoChamado,
  limiteChamado,
  setLimiteChamado,
  selectedSub,
  setSelectedSub,
  canShow,
  setCanShow,
  clearStates
}: props) {
  const formAnonimo = form.preenchimentoDeslogado && form.preenchimentoWeb;

  const { t } = useTranslation('translation');

  const mapOptionsKeys = {
    naoconforme: `${t('checklists.formModal.inNonConformity')}`,
    conforme: `${t('checklists.formModal.inConformity')}`,
    sempre: `${t('checklists.formModal.always')}`,
    nunca: `${t('checklists.formModal.never')}`
  };

  const allSubitems: ChecklistSubitem[] = [];

  if (form.itens) {
    form.itens.forEach(item => {
      item.subitens && item.subitens.forEach(sub => allSubitems.push(sub));
    });
  }

  const getAllClients = async () => {
    try {
      const token = await AttToken();
      if (token) {
        const body = { ...token, empresa: token.userEmpresa };
        const result = await customerService.getAllClients(body, true);
        return result.clientList;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getTypes = async () => {
    try {
      const token = await AttToken();
      if (token) {
        const response = await NotificationsService.getTypes(token, 'chamado');
        return response;
      }
    } catch (err) {
      console.error(err);
    }
  };
  type ValueMutate = {
    subId: string | null,
    subIndex: number,
    itemid: string
  };

  const getOptionsFn = async (value: ValueMutate) => {
    const token = await AttToken();
    if (token) {
      setCanShow(false);
      const response = await checklistService.getOptionsBySubitem(token, form.id, selectedCustomer, value.subId, value.subIndex, value.itemid);
      setCanShow(true);
      form.itens[Number(value.itemid.split('|')[2])].subitens[value.subIndex].new_id = response.newId;
      return response;
    }
  };

  const results = queryFn.useFetchMultiple([
    {
      key: 'customers',
      fn: getAllClients,
    },
    {
      key: 'getTickets',
      fn: getTypes,
    }
  ]);

  const isLoading = results?.some((result: any) => result.isLoading);
  const isFetching = results?.some((result: any) => result.isFetching);

  const getOptions = queryFn.useMutate('getOptionsBySubitem', getOptionsFn);

  useEffect(() => {
    if (getOptions.data && getOptions.data.result) {
      setChamadoObrigatorio(getOptions.data.result.chamadoObrigatorio);
      setLimiteChamado(Number(getOptions.data.result.limiteChamado));
      setTipoChamado(getOptions.data.result.tipoChamado);
    } else {
      setChamadoObrigatorio('naoconforme');
      setLimiteChamado(0);
      setTipoChamado([]);
    }
  }, [getOptions.data]);

  return (
    <>
      {isLoading || isFetching
        ? <>
          <>{!formAnonimo ?
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Skeleton variant="rounded" height={40} sx={{ width: '100%' }} />
              <Skeleton variant="rounded" height={60} sx={{ width: '80%', marginTop: '10px' }} />
            </div> :
            <div style={{ width: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
              <Skeleton className="input is-large" width={300} />
              <Skeleton variant="text" width={250} height={30} />
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'initial', width: '100%' }}>
                <Skeleton variant="text" width={100} style={{ marginBottom: '-.8em', alignSelf: 'initial', display: "flex" }} />
                <Skeleton className="input is-large" style={{ marginBottom: '-.8em' }} />
              </div>
            </div>
          }
          </>
        </>
        : <>
          {formAnonimo
            ? <h1 style={{ alignSelf: 'center', fontSize: '1.6em' }}>{t('formDetails.Formulario_Anonimo')}</h1> :
            <Autocomplete
              size="small"
              onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona cliente')}
              value={(selectedCustomer && {
                value: selectedCustomer,
                label: (results[0].data as any[])?.find((ele: ClientType) => ele.id === selectedCustomer)?.nome
              }) || null}
              id="combo-box-demo"
              sx={{ marginTop: '10px', width: '100%' }}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              filterSelectedOptions
              options={
                (results[0].data as any[])
                  .sort((a: ClientType, b: ClientType) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1; })
                  .filter((e: ClientType) => e.status === 'ativo')
                  .map((ele: ClientType) => ({
                    label: ele.nome,
                    value: ele.id,
                  }))}
              onChange={(event: any, newValue: { label: string, value: string | null | undefined } | null, reason: any, details: any) => {
                if (details) {
                  setCanShow(false);
                  setSelectedCustomer(details.option.value);
                  clearStates();
                } else setSelectedCustomer('');
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={option.value}>
                  <span>{option.label}</span>
                </li>)}
              renderInput={(params) => <TextField {...params} label={t('teamManage.modal.customer')} />}
            />
          }
          {
            selectedCustomer === '' ?
              (<div style={{ margin: '10px', border: '1px solid lightgray', padding: '15px', alignSelf: 'center' }}>
                <p style={{ color: 'gray', fontSize: '15px', fontWeight: 500, textAlign: 'center' }}>
                  {t('formDetails.GeneralTab.Selecione_um_cliente')}
                </p>
              </div>)
              :
              <>
                <StyledH1Subitem>{t('formDetails.sub_item_settings.Config_Subitens')}</StyledH1Subitem>
                <Autocomplete
                  size="small"
                  onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona subitem')}
                  id="combo-box-demo"
                  sx={{ width: '100%' }}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  filterSelectedOptions
                  disableClearable
                  options={
                    allSubitems
                      .sort((a, b) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1; })
                      .map((ele: any) => ({
                        label: ele.nome,
                        value: JSON.stringify(ele),
                      }))}
                  onChange={(event: any, newValue: { label: string, value: string } | null, reason: any, details: any) => {
                    if (details) {
                      const sub: SubitemChecklist = JSON.parse(details.option.value);
                      setSelectedSub(details.option.value);
                      getOptions.mutateAsync({ subId: sub.new_id || null, subIndex: Number(sub.id), itemid: sub.itemid });
                    } else {
                      setSelectedCustomer('');
                    }
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props} key={option.value}>
                      <span>{option.label}</span>
                    </li>)}
                  renderInput={(params) => <TextField {...params} label={t('formDetails.sub_item_settings.Selecione_Subitem')} />}
                />
                {canShow && !getOptions.isPending ?
                  <>
                    {isLoading || isFetching ?
                      <>
                        <Skeleton variant='rounded' width={'100%'} height={40} />
                      </> :
                      <Autocomplete
                        size="small"
                        onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona chamado')}
                        multiple
                        value={tipoChamado?.map((ele) => (
                          {
                            value: Number(ele),
                            label: (results[1].data as any[])?.find((elem: any) => Number(elem.id) === Number(ele))?.nome
                          }
                        )) || undefined}
                        id="combo-box-demo"
                        sx={{ marginTop: '10px', width: '100%' }}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        filterSelectedOptions
                        disableClearable
                        options={
                          (results[1].data as any[])?.sort((a: typeToSend, b: typeToSend) => {
                            return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1;
                          })
                            ?.filter((e: typeToSend) => e.tipo === 'chamado')
                            ?.map((ele: typeToSend) => ({
                              label: ele.nome,
                              value: ele.id,
                            }))}
                        onChange={(event: any, newValue: { label: string, value: number | null | undefined }[] | null, reason: any, details: any) => {
                          const value = details?.option.value as number;
                          if (tipoChamado?.includes(Number(value))) {
                            setTipoChamado((prevState: any) => prevState ? prevState.filter((el: any) => el !== Number(details.option.value)) : []);
                          } else {
                            setTipoChamado([...tipoChamado as number[], Number(value)]);
                          }
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.value}>
                            <span>{option.label}</span>
                          </li>)}
                        renderInput={(params) => <TextField {...params} label={t('formDetails.GeneralTab.Selecione_um_chamado')} />}
                      />
                    }
                    <Label>
                      <span className='limit-span'>{t('formDetails.sub_item_settings.Limite_por_subitem')}:</span>
                      <WeightInput
                        type="number"
                        onClick={() => trackEventMatomo('modal config form', 'click', 'input', 'adiciona valor')}
                        value={limiteChamado ? limiteChamado : undefined}
                        onChange={(e: any) => setLimiteChamado(Number(e.target.value))}
                      />
                    </Label>
                    {!limiteChamado
                      && <span
                        style={{ color: 'red' }}>
                        {t('checklists.formModal.noLimitDefined')}
                      </span>}
                    {JSON.parse(selectedSub).tipo === 'avaliacao'
                      && <FormControl sx={{ marginTop: '10px' }} fullWidth>
                        <InputLabel id="demo-simple-select-label">{t('formDetails.sub_item_settings.Abertura_de_chamado')}</InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label={t('formDetails.sub_item_settings.Abertura_de_chamado')}
                          value={chamadoObrigatorio}
                          onChange={(ev) => {
                            setChamadoObrigatorio(ev.target.value);
                          }}
                        >
                          {Object.keys(mapOptionsKeys).map(e => (
                            <MenuItem key={e} value={e}>{mapOptionsKeys[e as keyof typeof mapOptionsKeys]}</MenuItem>
                          ))}
                          <MenuItem value={10}>Ten</MenuItem>
                          <MenuItem value={20}>Twenty</MenuItem>
                          <MenuItem value={30}>Thirty</MenuItem>
                        </Select>
                      </FormControl>}
                  </>
                  : getOptions.isPending
                    ? <Stack
                      sx={{ marginTop: '10px' }}
                      width='100%'
                      direction="column"
                      justifyContent="center"
                      alignItems="flex-start"
                      spacing={1}
                    >
                      <Skeleton height={40} variant="rounded" width='100%' />
                      <Skeleton variant="text" width='150px' />
                      <Skeleton variant="text" width='350px' />
                      <Skeleton height={40} variant="rounded" width='100%' />
                    </Stack>
                    : <></>}
              </>}
        </>}
    </>
  );
}
